import { Grid, GridItem } from "@chakra-ui/react";
import { ImageCaptionFactory } from "../imageCaptionComponent";
import { richTextBlockFactory } from "../richText";
import { DownloadBlockFactory } from "../downloadBlock";

export function getColumnBlock(blockData: ContentBlock, index: number) {
  let blockFactory;
  switch (blockData?.content?.contentType) {
    case "richTextEditorComponent":
      blockFactory = richTextBlockFactory(blockData, index, {
        fundsDetailPage: true,
        fullWidth: true,
      });
      break;
    case "mediaFullwidthComponent":
      blockFactory = ImageCaptionFactory(blockData, index, {
        isFullWidth: true,
        aspectRatio: "5:4",
      });
      break;
    case "downloadList":
      blockFactory = DownloadBlockFactory(blockData, index);
      break;
    default:
      return null;
  }

  return blockFactory;
}

export function ColumnLayout(data: ContentBlock, key: number) {
  return (
    <Grid key={key} templateColumns="repeat(12, 1fr)" gap={{ base: 8, xl: 10 }}>
      {data.areas?.map((area, areaIndex) => (
        <GridItem
          key={area.alias ?? areaIndex}
          colSpan={{
            base: 12,
            xl: area.columnSpan ?? 12,
          }}
          display="flex"
          alignItems="center"
        >
          {area.items?.map((block, blockIndex) =>
            getColumnBlock(block, blockIndex),
          )}
        </GridItem>
      ))}
    </Grid>
  );
}
